import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { getExchangeUserGroupStatusGridValues } from '../../../../../utils/uiSettings/exchange/exchange-protection.values';
import { html, TemplateResult } from 'lit';
import { ExchangeUserGroupStatus } from '../../../../../utils/uiSettings/exchange/exchange-protection.types';

export enum Column {
  NAME = 1,
  STATUS = 2,
}

export enum ColumnKeys {
  NAME = 'name',
  STATUS = 'status',
}

export const GRID_COLUMNS = [Column.NAME, Column.STATUS];

export const FILTERS = [{ [ColumnKeys.NAME]: { contains: '' } }, { [ColumnKeys.STATUS]: { in: [] } }];
export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.NAME, ColumnKeys.STATUS];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.NAME,
      key: ColumnKeys.NAME,
      columnName: translateFn('Group name'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
    {
      column: Column.STATUS,
      key: ColumnKeys.STATUS,
      columnName: translateFn('Status'),
      type: ColumnType.ENUM,
      values: getExchangeUserGroupStatusGridValues(),
      removable: false,
      filteringDisabled: true,
      editingDisabled: true,
    },
  ];
}

export function statusCellCustomRenderer(
  rowData: unknown & { item: { status: ExchangeUserGroupStatus } }
): TemplateResult {
  const cellText = rowData.item.status ? translateFn('Enabled') : translateFn('Disabled');
  return html`<span class="cell-label">${cellText}</span>`;
}
